export default "__VITE_ASSET__b8ad5654__"